import { createElement } from "../../utils";

export class Switcher {
    constructor(container, options, onChange) {
        this.container = container;
        this.options = options;
        this.activeTab = 0;
        this.init();
        this.onChange = onChange;
    }

    init() {
        // Create main container
        this.element = createElement('div');
        this.element.className = 'switcher';  
        
        // Create buttons container 
        this.buttonsContainer = createElement('div', { class: 'switcher-buttons bg-gray-100 font-12 border-1 border-gray-100 flex rounded-lg overflow-hidden no-select' });
        
        // Create content container
        this.contentContainer = createElement('div');
        this.contentContainer.className = 'switcher-content';
        
        // Create buttons and content
        this.buttons = [];
        this.contents = [];
        
        this.options.forEach((option, index) => {
            // Create button
            const button = createElement('div', { class: 'b-0 flex-1 font-500 font-600 p-8 switcher-button text-center flex-center gap-4' }, option.label);
            if (index === this.activeTab) {
                button.classList.add('active');
            }
            
            button.addEventListener('click', () => this.switchTab(index));
            this.buttons.push(button);
            this.buttonsContainer.appendChild(button);
            
            // Create content
            const content = createElement('div');
            content.className = 'switcher-tab';
            if(option.content instanceof HTMLElement) {
                content.appendChild(option.content);
            }else{
                content.innerHTML = option.content;
            }
            if (index === this.activeTab) {
                content.classList.add('active');
            }
            this.contents.push(content);
            this.contentContainer.appendChild(content);
        });
        
        // Append everything to main element
        this.element.appendChild(this.buttonsContainer);
        this.element.appendChild(this.contentContainer);
        
        // Add styles
        const styles = createElement('style');
        styles.textContent = `
            .switcher {
                max-width: 600px;
                margin: 0 auto;
            }
            
            .switcher-button.active {
                background: #4263EB;
                color: white;
            }
            
            .switcher-tab {
                display: none;
            }
            
            .switcher-tab.active {
                display: block;
            }
        `;
        
        this.element.appendChild(styles);
        
        // Add to container
        this.container.appendChild(this.element);

        if (this.onChange) {
            this.onChange(this.activeTab);
        }
    }
    
    switchTab(index) {
        // Remove active class from current active elements
        this.buttons[this.activeTab].classList.remove('active');
        this.contents[this.activeTab].classList.remove('active');
        
        // Update active tab
        this.activeTab = index;
        
        // Add active class to new   active elements
        this.buttons[this.activeTab].classList.add('active');
        this.contents[this.activeTab].classList.add('active');

        if (this.onChange) {
            this.onChange(this.activeTab);
        }
    }

    // Method to get a specific tab content
    getTabContent(index) {
        if (index >= 0 && index < this.contents.length) {
            return this.contents[index];
        }
        return null;
    } 

    getCurrentTabIndex(){
        return this.activeTab;
    }
    
}